import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../../services/data.service";
import {ToastrService} from "ngx-toastr";
import {FormsModule} from "@angular/forms";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    imports: [
        FormsModule,
        NgIf
    ],
    styleUrl: './settings.component.scss'
})
export class SettingsComponent implements OnInit {

    private dataService = inject(DataService);
    private toastrService = inject(ToastrService);

    public newPass = '';
    public newPassConfirm = '';
    public user: any;
    public id_desk: any;

    ngOnInit(): void {
        this.newPass = null;
        this.newPassConfirm = null;

        this.dataService.request('User/get').subscribe(response => {
            this.user = response.user;
            this.id_desk = response.user.id_desk === null ? "" : response.user.id_desk;
        });
    }

    updateUser(): void {
        this.dataService.request('User/update', {
            password: this.newPass,
            id_desk: this.id_desk,
        }).subscribe(() => {
            this.toastrService.success('Daten wurden gespeichert');
            this.newPass = null;
            this.newPassConfirm = null;
        });
    }

}
